var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Download"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00085 11.7843C8.65585 11.7843 8.37585 11.5043 8.37585 11.1593V1.12512C8.37585 0.780122 8.65585 0.500122 9.00085 0.500122C9.34585 0.500122 9.62585 0.780122 9.62585 1.12512V11.1593C9.62585 11.5043 9.34585 11.7843 9.00085 11.7843Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00089 11.7843C8.83506 11.7843 8.67506 11.7184 8.55839 11.6001L6.12839 9.16094C5.88506 8.91594 5.88589 8.52011 6.13006 8.27677C6.37506 8.03344 6.77006 8.03344 7.01339 8.27844L9.00089 10.2743L10.9884 8.27844C11.2317 8.03344 11.6267 8.03344 11.8717 8.27677C12.1159 8.52011 12.1167 8.91594 11.8734 9.16094L9.44339 11.6001C9.32672 11.7184 9.16672 11.7843 9.00089 11.7843Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2856_1242",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 18,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.66687 4.44385H17.3334V15.8972H0.66687V4.44385Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2856_1242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.646 15.8972H4.3627C2.3252 15.8972 0.66687 14.2397 0.66687 12.2013V8.13051C0.66687 6.09718 2.32104 4.44385 4.3552 4.44385H5.13937C5.48437 4.44385 5.76437 4.72385 5.76437 5.06885C5.76437 5.41385 5.48437 5.69385 5.13937 5.69385H4.3552C3.0102 5.69385 1.91687 6.78635 1.91687 8.13051V12.2013C1.91687 13.5505 3.01354 14.6472 4.3627 14.6472H13.646C14.9894 14.6472 16.0835 13.553 16.0835 12.2097V8.13968C16.0835 6.79051 14.986 5.69385 13.6385 5.69385H12.8619C12.5169 5.69385 12.2369 5.41385 12.2369 5.06885C12.2369 4.72385 12.5169 4.44385 12.8619 4.44385H13.6385C15.676 4.44385 17.3335 6.10218 17.3335 8.13968V12.2097C17.3335 14.243 15.6785 15.8972 13.646 15.8972Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.a79f8280.svg";
export { ForwardRef as ReactComponent };